<template>
  <div class="box box-secondary collapsed-box">
    <div class="box-header with-border">
      <h3 class="box-title">
        <i class="fa fa-money mr-5"></i>
        {{'amount_without_returns' | translate}}
      </h3>
      <div class="box-tools pull-right">
        <div class="box-tools pull-right" title="Details einblenden">
          <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-plus"></i></button>
        </div>
      </div>
    </div>
    <div class="box-body">
      <template v-if="dataArray.length > 0">
        <table class="table table-hover table-responsive no-padding">
          <thead>
          <tr>
            <th>{{'marketplace' | translate}}</th>
            <th class="text-right">{{'total' | translate}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="r in dataArray">
            <td>{{r | translate}}</td>
            <td class="text-right">{{channelData[r].amount_without_returns | currency}}</td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <td class="text-bold"><h5>{{ 'amount' | translate }}</h5></td>
            <td class="text-bold text-right">
              <h5>
                <template v-if="loading">
                  <i class="fa fa-spinner fa-spin"></i>
                </template>
                <template v-else>
                  {{getTotal | currency}}
                </template>
              </h5>
            </td>
          </tr>
          </tfoot>
        </table>
      </template>
      <template v-else>
        <div class="callout callout-info">
          <h4>{{'no_data_at_this_time' | translate}}</h4>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['channelData', 'loading'],
    data () {
      return {
      }
    },
    methods: {
    },
    mounted () {
    },
    computed: {
      dataArray () {
        return Object.keys(this.channelData)
      },
      getTotal () {
        let ret = 0
        for (let r in this.channelData) {
          ret += this.channelData[r].amount_without_returns
        }
        return ret
      }
    },
    watch: {
      channelData () {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/tools/PriceBoxMpComponent.vue